import { render, staticRenderFns } from "./ArenaEquipmentForm.vue?vue&type=template&id=9bc3ddb2"
import script from "./ArenaEquipmentForm.vue?vue&type=script&lang=js"
export * from "./ArenaEquipmentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports